import { FormatService, FormatData } from "./FormatService";
import { Forsteg, RootState } from "@/store/types";
import { VilkenRollText, DinMisstankeText } from "@/store/map";

export class ForstegFormatService extends FormatService {
    private getVilkenRoll({ vilkenroll }: Forsteg): string {
        if (vilkenroll) {
            return this.$t(VilkenRollText[vilkenroll]);
        }
        return "";
    }

    private getMisstanke({ misstanke }: Forsteg): string {
        if (misstanke) {
            return this.$t(DinMisstankeText[misstanke]);
        }
        return "";
    }

    public getHeader(): string {
        return "";
    }

    public getFormData(state: RootState): Array<FormatData> {
        const { forsteg } = state;
        return [
            {
                textnyckel:
                    "impulskontrollutredning.anmalan.forsteg.lamnatips.vilkenroll.etikett.vilkenroll",
                value: this.getVilkenRoll(forsteg),
            },
            {
                textnyckel:
                    "impulskontrollutredning.anmalan.forsteg.lamnatips.misstanke.etikett.misstanke",
                value: this.getMisstanke(forsteg),
            },
        ];
    }
}
